import { UpperCasePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { capitalize } from 'lodash';
import * as moment from 'moment';
import { exportToCsv } from 'src/app/utils/common.utils';

@Injectable({
  providedIn: 'root'
})
export class CsvService {
  upperCase = new UpperCasePipe()

  constructor() { }
  gettingCancelledBadge(trip: any) {
    let result = '';
    if (trip.status === 'cancelled' && trip.flags) {
      if (trip.flags.isBillable) {
        result += ' - Billable';
      }
      if (trip.flags.isNoShow) {
        result += ' - No Show';
      }
    }
    return result;
  }
  // Pulls a plain numeric value out of fare fields that are sometimes
  // stored as a raw number and sometimes as an object like { fare, from, to }.
  private extractFareAmount(value: any): number {
    if (value === null || value === undefined || value === '') return 0;
    if (typeof value === 'number') return value;
    if (typeof value === 'object') {
      const nested = value.fare ?? value.total ?? value.value;
      return typeof nested === 'number' ? nested : 0;
    }
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  }

  // The grand total, as shown in Trip Details, lives on fare.breakdown.total.
  // Fall back to fare.total for records where breakdown isn't populated.
  private extractTotalFare(fare: any): number {
    if (!fare) return 0;
    return this.extractFareAmount(fare.breakdown?.total ?? fare.total);
  }

  generateTripItineraryReport(trips:any, date:any, timezone:any,preLevelOfService:any, preSpacetypes:any, preServiceAreas:any) {
    const table = [
      [
        "Trip ID",
        "Trip Status",
        "Created At",
        "Service Area",
        "Pick-up Address",
        "Pick-up Date",
        "Drop-Off Address",
        "Drop-Off Date",
        "Actual Miles",
        "LOS",
        "Space Type",
        "Passenger Name",
        "Contact Number",
        "Phone Number",
        "Driver Name",
        "Dispatcher Notes",
        "Private Notes",

        "Special Fare",
        "Total Fare",
        "Cancel Charges",
        "No Show Charges",
        "Payment Status",
      ]];
    trips.forEach((trip:any) => {
      let acceptedDate, pickupDate, arrivedDate, endDate, finishDate, scheduleTime, appointmentTime, createdAt = ' ';
      if (trip.scheduleTime) {
        scheduleTime = moment(trip.scheduleTime).tz(timezone).format("MMM DD, YYYY : HH:mm");
      }
      if (trip.createdAt) {
        createdAt = moment(trip.createdAt).tz(timezone).format("MMM DD, YYYY : HH:mm");
      }
      if (trip.appointmentTime) {
        appointmentTime = moment(trip.appointmentTime).tz(timezone).format("MMM DD, YYYY : HH:mm");
      }
      if (trip.job) {
        if (trip.job.trackInfoJob) {
          if (trip.job.trackInfoJob.jobAccepted) {
            if (trip.job.trackInfoJob.jobAccepted.time) {
              acceptedDate = moment(trip.job.trackInfoJob.jobAccepted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobArrived) {
            if (trip.job.trackInfoJob.jobArrived.time) {
              pickupDate = moment(trip.job.trackInfoJob.jobArrived.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobStarted) {
            if (trip.job.trackInfoJob.jobStarted.time) {
              arrivedDate = moment(trip.job.trackInfoJob.jobStarted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobCompleted) {
            if (trip.job.trackInfoJob.jobCompleted.time) {
              endDate = moment(trip.job.trackInfoJob.jobCompleted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }

          if (trip.job.trackInfoJob.jobFinished) {
            if (trip.job.trackInfoJob.jobFinished.time) {
              finishDate = moment(trip.job.trackInfoJob.jobFinished.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }

        }

      }

      function capitalize(str:any) {
        return str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : ' ';
      }

      const fare = trip.fare || {};

      let paymentStatus = '';
      if (trip.member?.memberType === 'private_pay') {
        if (trip.flags?.isFullPaid) paymentStatus = 'Paid';
        else if (trip.flags?.isPartiallyPaid) paymentStatus = 'Partially Paid';
      }

      let data = [
        trip.reference && trip.suffix ? trip.reference + '-' + trip.suffix : ' ',
        // trip.status ? capitalize(trip.status) : '',
        trip.status ? capitalize(trip.status) : '',
        createdAt ? createdAt : ' ',
        preServiceAreas[trip.serviceArea] ? preServiceAreas[trip.serviceArea].title : ' ',
        trip.pickup.address ? trip.pickup.address.name : ' ',
        trip.pickup ? moment(trip.pickup.time).tz(timezone).format("MM/DD/YYYY HH:mm") : ' ',
        trip.destination.address ? trip.destination.address.name : ' ',
        trip.destination ? moment(trip.destination.time).tz(timezone).format("MM/DD/YYYY HH:mm") : ' ',
        trip.miles ? trip.miles : '0',
        preLevelOfService[trip.levelOfService] ? (this.upperCase.transform(preLevelOfService[trip.levelOfService].title)) : ' ',
        preSpacetypes[trip.spaceType] ? (this.upperCase.transform(preSpacetypes[trip.spaceType].title)) : ' ',
        trip ? trip.member.displayName : ' ',
        trip.member && trip.member.contactNumber ? `\t${trip.member.contactNumber}` : 'N/A',
        trip.pickup && trip.pickup.phoneNumber ? `\t${trip.pickup.phoneNumber}` : 'N/A',
        trip.driver ? trip.driver.displayName : ' ',
        trip.generalNotes ? trip.generalNotes : ' ',
        trip.privateNotes ? trip.privateNotes : ' ',

        trip.preSpecialRate ? Number(trip.preSpecialRate).toFixed(2) : '',
        this.extractTotalFare(fare).toFixed(2),
        this.extractFareAmount(fare.cancelBreakdown?.cancelCharges).toFixed(2),
        this.extractFareAmount(fare.cancelBreakdown?.noShowCharges).toFixed(2),
        paymentStatus,
      ]
      table.push(data)
    });

    exportToCsv(`reports-${moment(date[0]).tz(timezone).format("MM-DD-YYYY")}-${moment(date[1]).tz(timezone).format("MM-DD-YYYY")}.csv`, table);
  }

  generatePrivatePayReport(trips: any,overviewData:any, dateRange:any) {
    let totalFare = 0;
    let totalOfferedFare = 0;
    let totalCommission = 0;
    const table = [
      [
        "Funding Source",
        "Company",
        "Reference ID",
        "Member",
        "Service Date",
        "Miles",
        "Space Type",
        "LOS",
        "Rate",
        "Offered Rate",
        "Commission",
      ]];
    trips.forEach((trip: any) => {
      const commission = trip?.fare?.total - trip?.offeredFare?.total;
      const fare = trip?.fare?.total ? trip?.fare?.total : 0;
      const offeredFare = trip?.offeredFare?.total ? trip?.offeredFare?.total : 0;
      let data = [
        trip.fundingsource ? trip.fundingsource.title : ' ',
        trip.company ? trip.company.name : ' ',
        trip.id ? trip.reference + '-' + trip.suffix : ' ',
        trip?.member?.displayName,
        trip.pickup ? moment(trip.pickup.time).format("MM/DD/YYYY HH:mm") : ' ',
        trip.miles ? trip.miles : '0',
        trip.spaceType ? (this.upperCase.transform(trip.spaceType.title)) : ' ',
        ((trip.levelOfService ? (this.upperCase.transform(trip.levelOfService.title)) : ' ')),
        fare ? fare.toFixed(2) : ' ',
        offeredFare ? offeredFare.toFixed(2) : ' ',
        commission ? commission.toFixed(2) : ' '
      ]
      table.push(data)
    });
    table.push([...new Array(11).fill(' ')]);
    table.push([...new Array(11).fill(' ')]);
    table.push([...new Array(8).fill(' '), 'Total Rate', 'Total Offered Rate', 'Total Commission']);
    table.push([...new Array(8).fill(' '), overviewData && overviewData.totalFare ? overviewData.totalFare.toFixed(2) : ' ', overviewData && overviewData.totalOfferedFare ? overviewData.totalOfferedFare.toFixed(2) : ' ', overviewData && overviewData.totalComission ? overviewData.totalComission.toFixed(2) : ' ']);
    exportToCsv(`report-${moment(dateRange[0]).format("MM-DD-YYYY")}-${moment(dateRange[1]).format("MM-DD-YYYY")}.csv`, table);
  }
  generateRawTripReport(trips: any, date: any, timezone: any) {
    const table = [
      [
        "trip_id",
        "trip_status",

        "passenger_name",
        "contact_number",
        "phone_number",
        "dob",
        "weight",

        "pu_address",
        "pu_date",

        "do_address",
        "do_date",
        "appointment_type",
        "trip_miles",

        "funding_source",

        "driver_name",

        "vehicle",

        "spacetype",

        // events
        "onway_time",
        "onway_coords",
        "arrived_time",
        "arrived_coords",
        "in_progress_time",
        "in_progress_coords",
        "completed_time",
        "completed_coords",

        // fare
        "total_fare",
        "final_fare",

        "base_fare",
        "base_fare_code",
        "per_mile",
        "per_mile_code",

        "created_at",

        "driver_notes",
        "biller_notes",

        "service_area",
        "level_of_service",

        "wait_time",
        "trip_miles",
        "trip_time",
        "total_trip_miles",
        "total_trip_time",
        "Addon Fare",
      ]
    ];

    trips.forEach((trip: any) => {
      // extract events
      const onway = trip.events?.find((e: any) => e.status === "onway");
      const arrived = trip.events?.find((e: any) => e.status === "arrived");
      const inProgress = trip.events?.find((e: any) => e.status === "in_progress");
      const completed = trip.events?.find((e: any) => e.status === "completed");

      // offered fare as “final”
      const fare = trip.fare || {};
      const offeredFare = trip.offeredFare || {};

      const data = [
        trip.reference || "",
        trip.status || "",

        trip.member?.displayName ? trip.member?.displayName : "",
        trip.member?.contactNumber || "",
        trip.member?.phoneNumber || "",
        trip.member?.dateOfBirth
          ? moment(trip.member.dateOfBirth).format("MMM DD, YYYY")
          : "",
        trip.member?.weight || "",

        trip.pickup?.address?.name || "",
        trip.pickup?.time
          ? moment(trip.pickup.time).tz(timezone).format("MMM DD, YYYY : HH:mm")
          : "",

        trip.destination?.address?.name || "",
        trip.destination?.time
          ? moment(trip.destination.time).tz(timezone).format("MMM DD, YYYY : HH:mm")
          : "",
        trip.appointmentType?.title || "",
        trip.miles || "",

        trip.fundingsource?.title || "",

        trip.driver ? `${trip.driver.displayName}` : "",

        trip.vehicle
          ? `${trip.vehicle.make} - ${trip.vehicle.model} - ${trip.vehicle.vin}`
          : "",

        (this.upperCase.transform(trip.spaceType?.title)) || "",

        // events
        onway?.time
          ? moment(onway.time).tz(timezone).format("MMM DD, YYYY : HH:mm")
          : "",
        onway ? `${onway.latitude},${onway.longitude}` : "",

        arrived?.time
          ? moment(arrived.time).tz(timezone).format("MMM DD, YYYY : HH:mm")
          : "",
        arrived ? `${arrived.latitude},${arrived.longitude}` : "",

        inProgress?.time
          ? moment(inProgress.time).tz(timezone).format("MMM DD, YYYY : HH:mm")
          : "",
        inProgress ? `${inProgress.latitude},${inProgress.longitude}` : "",

        completed?.time
          ? moment(completed.time).tz(timezone).format("MMM DD, YYYY : HH:mm")
          : "",
        completed ? `${completed.latitude},${completed.longitude}` : "",

        // fare
        fare.breakdown?.total || "",
        offeredFare.breakdown?.total || "",

        fare.breakdown?.baseFare || "",
        fare.baseFareCode || "",
        fare.breakdown?.perMileFare || "",
        fare.perMileCode || "",


        trip.createdAt
          ? moment(trip.createdAt).tz(timezone).format("MMM DD, YYYY : HH:mm")
          : "",

        trip.privateNotes || "",
        trip.generalNotes || "",

        trip.serviceArea?.title || "",
        (this.upperCase.transform(trip.levelOfService?.title)) || "",

        fare.breakdown?.waitTimeCharges || "",
        trip.miles || "",
        fare.breakdown?.duration || "",
        fare.breakdown?.distance || "",
        fare.breakdown?.duration || "",
        trip.addons.fare || ""
      ];

      table.push(data);
    });

    exportToCsv(
      `raw-report-${moment(date[0]).tz(timezone).format("MM-DD-YYYY")}-${moment(date[1])
        .tz(timezone)
        .format("MM-DD-YYYY")}.csv`,
      table
    );
  }
  generatePrivateFSPayReport(result: any, dateRange:any, source: any = '') {
    const showPayment = source !== 'original';
    const rawData = result?.data || [];
    const fsTrips = rawData.filter((trip: any) => trip?.fundingsource && (trip.fundingsource.title || trip.fundingsource._id));

    const table = [
      [
        "Funding Source",
        // "Company",
        "Driver",
        "Status",
        "Reference ID",
        "Member",
        "Service Date",
        "Miles",
        "Space Type",
        "LOS",

        // "Special Rate",
        "Flat",
        "Actual",
        ...(showPayment ? ["Payment Status", "Payment Type"] : []),

      ]];

    let totalFlat = 0;
    let totalActual = 0;
    let paidAmount = 0;
    let unpaidAmount = 0;
    let paidTrips = 0;
    let unpaidTrips = 0;

    fsTrips.forEach((trip: any) => {
      const preSpecial = Number(trip.preSpecialTotal || 0);
      const flatFS = Number(trip.flatFSTotal || 0);
      const actualFS = Number(trip.actualFSTotal || 0);
      totalFlat += flatFS;
      totalActual += actualFS;

      // settlement split of the same Actual figure the sheet already totals
      if (trip?.payment?.status === 'paid') {
        paidTrips += 1;
        paidAmount += actualFS;
      } else {
        unpaidTrips += 1;
        unpaidAmount += actualFS;
      }

      let data = [
        trip.fundingsource ? trip.fundingsource.title : ' ',
        trip?.driver ? trip?.driver?.displayName : ' ',
        trip.status + this.gettingCancelledBadge(trip),
        trip.reference +'-'+ trip.suffix || ' ',
        trip?.member?.displayName || ' ',
        trip.pickup ? moment(trip.pickup.time).format("MM/DD/YYYY HH:mm") : ' ',
        trip.miles ? trip.miles : '0',
        trip.spaceType ? (this.upperCase.transform(trip.spaceType.title)) : ' ',
        trip.levelOfService ? (this.upperCase.transform(trip.levelOfService.title)) : ' ',

        // preSpecial.toFixed(2),
        flatFS.toFixed(2),
        actualFS.toFixed(2),
        ...(showPayment
          ? [
            trip?.payment?.status ? this.upperCase.transform(trip.payment.status) : 'N/A',
            trip?.payment?.relationType && trip.payment.relationType !== 'none'
              ? this.upperCase.transform(trip.payment.relationType)
              : 'N/A',
          ]
          : []),

      ];
      table.push(data);
    });
    table.push([...new Array(9).fill(' ')]);
    table.push([...new Array(9).fill(' ')]);
    
    table.push([
      ...new Array(8).fill(' '),
      'Trips',
      ...(showPayment ? ['Paid Trips', 'Unpaid Trips'] : []),
      'Total Flat FS',
      'Total Actual FS',
      ...(showPayment ? ['Paid Amount', 'Unpaid Amount', 'Total Amount'] : []),
    ]);
    table.push([
      ...new Array(8).fill(' '),
      fsTrips.length,
      ...(showPayment ? [paidTrips, unpaidTrips] : []),
      totalFlat.toFixed(2),
      totalActual.toFixed(2),
      ...(showPayment ? [paidAmount.toFixed(2), unpaidAmount.toFixed(2), totalActual.toFixed(2)] : []),
    ]);
     console.log("table",table)

    exportToCsv(`report-${moment(dateRange[0]).format("MM-DD-YYYY")}-${moment(dateRange[1]).format("MM-DD-YYYY")}-fs.csv`, table);
  }

}



